class LSGFaq extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      active: 'active',
      faq: 'js-lsg-faq-item',
      faqQuestion: 'js-lsg-faq-item-question',
      faqAnswer: 'js-lsg-faq-item-answer',
    }

    this.selectors = {
      faqs: this.querySelectorAll(`.${this.classes.faq}`),
    }
  }

  connectedCallback() {
    this.handleFaqQuestionsClick();
  }

  handleFaqQuestionsClick() {
    if (!this.selectors.faqs.length) return;

    this.selectors.faqs.forEach((faq) => {
      const question = faq.querySelector(`.${this.classes.faqQuestion}`);
      const answer = faq.querySelector(`.${this.classes.faqAnswer}`);
      if (!question || !answer) return;

      question.addEventListener('click', () => {
        answer.style.maxHeight = faq.classList.contains(this.classes.active) ? 0 : `${answer.scrollHeight + 20}px`;
        faq.classList.toggle(this.classes.active);
      })
    })
  }
}

const customElementName = 'lsg-faq';
if (!customElements.get(customElementName)) {
  window.customElements.define(customElementName, LSGFaq);
}